// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__1EUmT","card":"Cards_card__3XcfW","infected":"Cards_infected__oSrcl","recovered":"Cards_recovered__24UeO","deaths":"Cards_deaths__15ZXp"};